import styled from "styled-components/macro";

export const ProjectCardContainer = styled.div`
  cursor: pointer;
  transition: scale 150ms ease-in-out, opacity 150ms ease-in-out;
  text-align: left;

  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  user-select: none;

  .project-cover {
    flex: none;
    width: min(100%, 229px);
  }

  &:hover:not(.disabled):not(.isDragging) .project-cover,
  &:focus-visible:not(.disabled):not(.isDragging) .project-cover {
    .cover-shine {
      opacity: 1;
      background-position: -30% 0;
      transition: opacity 150ms ease-in-out, background-position 800ms ease-in-out;
    }
  }

  &:hover:not(.disabled):not(.isDragging) {
    scale: 1.05;
  }

  &:focus-visible:not(.disabled):not(.isDragging) {
    scale: 1.05;
    outline: 2px solid var(--primary-cta);
    outline-offset: 2px;
  }

  &.disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.isDragging {
    opacity: 0.5;
    scale: 0.9;
    cursor: grabbing;
  }

  &:hover:not(.isDragging) .action-menu,
  &:focus-within .action-menu {
    opacity: 1;
  }

  @media (hover: none) {
    .action-menu {
      opacity: 1;
    }
  }

  .action-menu {
    flex: none;
    opacity: 0;
    transition: opacity 150ms ease-in-out;

    .icon-wrapper,
    .icon-button-wrapper:hover .icon-wrapper,
    .icon-button-wrapper:focus-visible .icon-wrapper {
      width: 24px;
      height: 24px;
      border-radius: 6px;
    }

    .icon-button-wrapper:active .icon-wrapper {
      width: 22px;
      height: 22px;
    }

    svg {
      circle {
        fill: var(--grey-0);
      }
    }

    .icon-button-wrapper:hover .icon-wrapper,
    .icon-button-wrapper:focus-visible .icon-wrapper {
      background-color: color-mix(in srgb, var(--grey-0) 10%, transparent);
    }

    .icon-button-wrapper:active .icon-wrapper {
      background-color: color-mix(in srgb, var(--grey-0) 18%, transparent);
    }

    .menu-item.deleteProject {
      .label {
        color: var(--danger-color);
      }
      .icon {
        path {
          fill: var(--danger-color);
        }
      }
    }
  }

  .project-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: min(100%, 229px);

    .project-title-row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 4px;
    }

    .project-title-text .title {
      transition: font-size 200ms ease-in-out;
    }

    .project-title-text.exporting .title {
      font-size: 16px; /* Scale down when exporting to prevent cutoff */
    }

    .project-subtitle-text {
      font-family: "Inter";
      font-weight: 500;
      font-size: 16px;
      color: var(--grey-2);
      line-height: 1.4em;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .project-subtitle-primary {
      font-size: 16px;
    }

    .project-subtitle-subtext {
      font-size: 13px;
    }

    .export-progress-bar {
      width: 100%;
      height: 4px;
      background-color: var(--grey-3);
      border-radius: 2px;
      overflow: hidden;
      margin: 4px 0;
    }

    .export-progress-fill {
      height: 100%;
      background: var(--primary-cta-light);
      background: linear-gradient(
        -45deg,
        color-mix(in srgb, var(--primary-cta-light) 70%, white),
        var(--primary-cta),
        color-mix(in srgb, var(--primary-cta-light) 85%, white),
        var(--primary-cta)
      );
      background-size: 400% 400%;
      border-radius: 2px;
      transition: width 300ms ease-out;
      animation: gradient 8s ease infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }

    .project-import-text {
      color: var(--grey-0);
      font-weight: 500;
      line-height: 120%;
    }
  }

  &.disabled {
    .project-last-edited {
      display: none;
    }
  }

  .project-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    margin-top: -8px;

    p {
      margin: 0;
    }

    .project-word-count {
      font-family: "Inter";
      font-weight: 500;
      font-size: 12px;
      color: var(--grey-0);
    }

    .project-last-edited {
      font-family: "Inter";
      font-weight: 500;
      font-size: 12px;
      color: var(--grey-0);

      &::before {
        content: "·";
        margin-right: 6px;
      }
    }
  }
`;
